module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/brush-wide-b8c4313ceafb97876bc0bf3725b1d31a.svg";